import script from "./AnswerPop.vue?vue&type=script&setup=true&lang=js"
export * from "./AnswerPop.vue?vue&type=script&setup=true&lang=js"

import "./AnswerPop.vue?vue&type=style&index=0&id=5eb562d3&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5eb562d3"]])

export default __exports__